'use strict';

import { ModalShowHide } from 'components/modal';
import Map from 'components/spsPickupPointMap';
import { applyRendering } from 'util/render';
import { getPosition } from 'product/findinstore';
import { woosmapInitSPS, woosmapListenerForModalClose } from 'woosmap';
import { addLabelToLocation } from 'product/findinstore';
export default class SlovakParcelService {
    constructor () {
        // Default coords to Slovakia
        this.coordinates = {
            lat: 48.669025,
            long: 19.699024
        };
        this.wasMapInitialized = false;
        this.elementSelector = '#spsPickupPointMapModal';
    }

    run () {
        this.$element = $(this.elementSelector);
        this.pickUpPointRadius = this.$element.data('radius');
        this.pickUpPointRadiusIndex = 0;
        this.addEventListeners();
        this.launch();
        this.observePickUpPointModal();
        this.observePickUpPointSelection();
        this.handleShowOnMap();
        this.mapListener();
        this.loadMorePickupPoints();
    }

    addEventListeners () {
        $(this.elementSelector).off('click', '#sps-usecurrentposition');

        $(this.elementSelector).on('click', '#sps-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();
            e.preventDefault();
            e.stopPropagation();
        });
    }

    launch () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitialized) {
            this.map = new Map(this.$element.find('#pickupPointMap'), [this.coordinates.lat, this.coordinates.long]);
            this.map.init();
            this.wasMapInitialized = true;
        }

        // Update map coordinates
        this.map.updateCoordinates(this.coordinates);
    }

    handlePickupResults (data) {
        this.map.updateMarkers(data.parcelShops);

        const $target = $('#pickup-point-results');
        $target.empty();

        // Display list
        var _self = this;
        if (data.parcelShops.length) {
            let html = '';
            let labelIndex = 0;
            data.parcelShops.map((shop) => {
                shop.storeLabel = addLabelToLocation(labelIndex);
                html += _self.renderParcelShopResult(shop);
                labelIndex++;
            });
            $target.html(html);

            if (this.pickUpPointRadiusIndex < this.pickUpPointRadius.length - 1) {
                $target.append(applyRendering('parcelShopsViewMore'));
            }
        } else {
            $target.append(applyRendering('parcelShopsEmpty'));
        }
    }

    renderParcelShopResult (data) {        
        var parcelShopData = {
            id: data.id,
            name: data.name,
            address: data.address,
            city: data.city,
            postalCode: data.postalCode,
            latitude: data.latitude,
            longitude: data.longitude,
        };
        if(data.storeLabel) {
            parcelShopData.storeLabel = data.storeLabel;
        }
        return applyRendering('parcelShopResult', parcelShopData);
    }

    observePickUpPointModal () {
        var _self = this;

        // Open pickup point modal (CTA edit has same class name)
        $('body').on('click', '.sps-pickup-point-btn', function (e) {
            e.preventDefault();

            const modal = new ModalShowHide(_self.elementSelector);

            woosmapInitSPS();

            modal.show();

            $(modal.modalBox).on('click', '.close-button-modal', () => {
                modal.hide();
            });

            $('body').on('pickupPoint:selectedPoint', function () {
                modal.hide();
            });
        });

        woosmapListenerForModalClose();
    }

    getPickupPointList () {
        var _self = this;
        var url = $('#pickupPointButtonSPS').data('url');

        // Get current radius or latest
        var radius = this.pickUpPointRadiusIndex > this.pickUpPointRadius.length - 1 ?
            this.pickUpPointRadius[this.pickUpPointRadius.length - 1] :
            this.pickUpPointRadius[this.pickUpPointRadiusIndex];

        var data = {
            lat: this.coordinates.lat,
            long: this.coordinates.long,
            radius: radius
        };

        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            data: data
        }).done(function (data) {
            _self.handlePickupResults(data);
            $.spinner().stop();
        }).fail(function () {
            $.spinner().stop();
        });
    }

    loadMorePickupPoints () {
        var _self = this;

        $('body').on('click', '.js-view-more-sps', function (e) {
            _self.pickUpPointRadiusIndex++;
            _self.getPickupPointList();
        });
    }

    observePickUpPointSelection () {
        // Check selection on modal
        $('body').on('click', '.js-select-sps-pup', function (e) {
            const id = $(e.currentTarget).data('id');
            const $result = $('.result[data-id="' + id + '"]');
            const name = $('.js-sps-pup-name', $result).text();
            const address = $('.js-sps-pup-address', $result).text();
            const city = $('.js-sps-pup-city', $result).text();
            const postalCode = $('.js-sps-pup-postal-code', $result).text();

            // Set only one result as selected
            $('.result').removeClass('result--selected');
            $result.addClass('result--selected');

            // Show selection recap and hide first CTA
            $('.js-sps-point-name').text(name);
            $('.js-sps-point-address1').text(address);
            $('.js-sps-point-city').text(city);
            $('.js-sps-point-postal-code').text(postalCode);
            $('.selectedSPSPickupRecap').removeClass('hide');
            $('.shipping-method-selected.shop-selected').addClass('fix-margin');
            $('.sps-first-selection-btn').addClass('hide');

            // Close modal and trigger next step
            $('body').trigger('pickupPoint:selectedPoint', {
                number: id,
                name: name,
                address1: address,
                city: city,
                postalCode: postalCode
            });
        });
    }

    handleShowOnMap () {
        var _self = this;

        // Handle when clicked "Show on map" on list
        $('body').on('click', '.js-sps-showonmap', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            _self.map.centerMapOnCoordinates(coords);
            _self.scrollToMap();
            e.preventDefault();
            e.stopPropagation();
        });
    }

    scrollToMap () {
        // For mobile only, show Map and scroll to it
        if (!Foundation.MediaQuery.atLeast('medium')) {
            const $map = this.$element.find('#pickupPointMap');
            $map.removeClass('hide-for-mobile');
            const $wrapper = $('#spsPickupPointMapModal');

            $wrapper.animate({
                scrollTop: $wrapper.get(0).scrollHeight
            });
        }
    }

    mapListener () {
        // Handle Geocoding update event
        $('body').on('spsPickupPointGeocode:update', this.$element, (e, res) => {
            if (res.success) {
                // Set active coordinates according to Google Geocoding's response
                this.coordinates.lat = res.data.lat;
                this.coordinates.long = res.data.long;
                // Update map with current coordinates
                this.map.updateCoordinates(this.coordinates);

                if (res.data.country && res.data.country === 'SK') {
                    this.getPickupPointList();
                } else {
                    const $target = $('#pickup-point-results');
                    $target.empty().append(applyRendering('parcelShopsEmpty'));
                }
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Google failed: ' + res.status);
            }
        });

        var _self = this;
        $('body').on('woosmap:chooseOptionSPS', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;

                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getPickupPointList();
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
            }
        });
    }

    detectLocationPickupPoint () {
        getPosition()
            .then((position) => {
                this.isGeolocalized = true;
                // Set active coordinates according to the browser's navigator
                this.coordinates.lat = position.coords.latitude;
                this.coordinates.long = position.coords.longitude;

                this.map.updateCoordinates(this.coordinates);
                const query = {
                    // eslint-disable-next-line no-undef
                    location: new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
                };
                this.map.geocode(query);
            })
            .catch((err) => {
                // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $('#sps-usecurrentposition').addClass('disabled');
            });
    }
}
